import React from 'react';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import PermissionElementWrapper from '../../../PermissionControls/PermissionElementWrapper';
import { SecondaryButton } from '../../../../components/Button';
import { BuilderHeader } from '../../../../components/Builder/BuilderHeader';
import {
  PermissionKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  activeSchemaIdSelector,
  builderSampledCohortSelector,
} from '../../../../redux/selectors/builder';
import usePermission from '../../../../utils/hooks/permissionHooks';
import { useShowBraze } from '../../../../utils/hooks';
import { ModalSliceType, openModal } from '../../../../redux/slices/modal';
import KubitTooltip from '../../../../components/KubitTooltip';
import LumosButton from '../../../../components/LumosButton';
import useShowLumosButton from '../../../../components/LumosButton/useShowLumosButton';

const CohortBuilderHeader = () => {
  const dispatch = useAppDispatch();
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const builderSampledCohort = useAppSelector(builderSampledCohortSelector);
  const showBraze = useShowBraze();

  const { checkIsPermitted } = usePermission();
  const isPermittedToExportToBraze = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.CohortBrazeExportCreate],
    schemaId: activeSchemaId,
  });

  const handleSyncToBraze = () => {
    dispatch(
      openModal({
        type: ModalSliceType.CreateSchedule,
        data: builderSampledCohort,
        id: builderSampledCohort?.id,
      }),
    );
  };

  const shouldShowLumosButton = useShowLumosButton(
    activeSchemaId,
    PermissionKey.CohortReportCreate,
    true,
  );

  return (
    <BuilderHeader
      queryType={QueryType.CohortSample}
      actions={
        <>
          {builderSampledCohort.id && showBraze && (
            <PermissionElementWrapper
              isPermitted={isPermittedToExportToBraze}
              isHalfOpacity={true}
            >
              <KubitTooltip
                disabled={!isPermittedToExportToBraze}
                content={'Sync to Braze'}
                placement="bottom"
              >
                <SecondaryButton
                  type="button"
                  isOutlined
                  disabled={!isPermittedToExportToBraze}
                  onClick={handleSyncToBraze}
                  trackContext="cohorts"
                  trackAction="sync to braze"
                >
                  Sync
                </SecondaryButton>
              </KubitTooltip>
            </PermissionElementWrapper>
          )}
        </>
      }
    >
      {shouldShowLumosButton && <LumosButton />}
      {builderSampledCohort?.name && (
        <BuilderUI.BuilderSubtitle>
          &#8226; {builderSampledCohort.name}
        </BuilderUI.BuilderSubtitle>
      )}
    </BuilderHeader>
  );
};

export default CohortBuilderHeader;
